module.exports = "/assets/bundles/a42d02fecc136674c5460348c7afb579.svg";